module.exports={render:function (){with(this) {
  return _m(0)
}},staticRenderFns: [function (){with(this) {
  return _h('div', ["\n  Some Content Here\n"])
}}]}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-12!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dynamic.vue
 ** module id = 83
 ** module chunks = 2
 **/